
import { Question } from '../types';

export const qur101Questions: Question[] = [
  {
    id: 'qur001',
    text: 'What are the different ways in which revelation (waḥī) came to the Prophet Muhammad ﷺ?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Through the angel Jibrīl appearing in human form', isCorrect: true },
      { id: 'b', text: 'Through the angel Jibrīl appearing in his true form', isCorrect: true },
      { id: 'c', text: 'Through direct discourse with Allāh SWT', isCorrect: true },
      { id: 'd', text: 'Through the sunlight', isCorrect: false },
      { id: 'e', text: 'Through other prophets', isCorrect: false }
    ],
    explanation: 'Revelation came to the Prophet Muhammad ﷺ in three primary ways: through the angel Jibrīl in human form, through Jibrīl in his true angelic form (which only happened twice because it was extremely overwhelming), and through direct discourse with Allāh SWT (which is where most ḥadīth qudsī comes from).',
    topic: 'qur101'
  },
  {
    id: 'qur002',
    text: 'How would the Prophet Muhammad ﷺ identify the angel Jibrīl when he appeared in human form?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'He had the blackest hair', isCorrect: true },
      { id: 'b', text: 'He wore the whitest clothing', isCorrect: true },
      { id: 'c', text: 'He was exceptionally tall', isCorrect: true },
      { id: 'd', text: 'No one recognized him, yet he didn\'t appear to come from far away', isCorrect: true },
      { id: 'e', text: 'He had wings visible to humans', isCorrect: false }
    ],
    explanation: 'When Jibrīl appeared in human form, the Prophet ﷺ would recognize him by his characteristics: tall stature, the blackest of hair, the whitest of clothing, and the fact that no one would know him, though he did not look like he came from far away.',
    topic: 'qur101'
  },
  {
    id: 'qur003',
    text: 'What are the stages of the revelation of the Qur\'ān?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Initial descent to the Lawḥ al-Maḥfūẓ', isCorrect: true },
      { id: 'b', text: 'Descent to the lowest level of Heaven (samā\' al-dunyā)', isCorrect: true },
      { id: 'c', text: 'Gradual revelation to Prophet Muhammad ﷺ over 23 years', isCorrect: true },
      { id: 'd', text: 'Immediate descent directly to the Prophet\'s heart', isCorrect: false }
    ],
    explanation: 'The Qur\'ān was revealed in stages: first to the Lawḥ al-Maḥfūẓ (the Preserved Tablet) all at once, then to the lowest level of Heaven (samā\' al-dunyā), and finally, gradually to Prophet Muhammad ﷺ over a period of 23 years.',
    topic: 'qur101'
  },
  {
    id: 'qur004',
    text: 'According to Sūrat Al-Furqān, why wasn\'t the Qur\'ān sent down all at once?',
    type: 'single',
    options: [
      { id: 'a', text: 'To make it easier for the Prophet ﷺ to memorize', isCorrect: false },
      { id: 'b', text: 'To steady the Prophet\'s heart and strengthen his faith', isCorrect: true },
      { id: 'c', text: 'Because the angel Jibrīl was busy with other tasks', isCorrect: false },
      { id: 'd', text: 'To punish the disbelievers gradually', isCorrect: false }
    ],
    explanation: 'According to Sūrat Al-Furqān, the Qur\'ān wasn\'t sent down all at once in order to steady the Prophet\'s heart/belief and keep it firm. The gradual revelation provided spiritual and psychological support during challenging times.',
    topic: 'qur101'
  },
  {
    id: 'qur005',
    text: 'What is the difference between Waḥī Matlū and Waḥī Ghair Matlū?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Waḥī Matlū is the literal word of God (the Qur\'ān)', isCorrect: true },
      { id: 'b', text: 'Waḥī Ghair Matlū cannot be recited in prayer', isCorrect: true },
      { id: 'c', text: 'Waḥī Ghair Matlū includes Ḥadīth and Ḥadīth Qudsī', isCorrect: true },
      { id: 'd', text: 'Waḥī Matlū has the highest number of fabrications', isCorrect: false }
    ],
    explanation: 'Waḥī Matlū is the literal word of God (the Qur\'ān) that can be recited in prayer. Waḥī Ghair Matlū cannot be recited in prayer and includes Ḥadīth (everything the Prophet ﷺ says) and Ḥadīth Qudsī (which communicates what Allāh means but not letter-for-letter). The highest number of fabrications is found in Waḥī Ghair Matlū, not Matlū.',
    topic: 'qur101'
  },
  {
    id: 'qur006',
    text: 'What are the primary characteristics of Makki surahs?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'They often begin with "Oh people" (addressing everyone)', isCorrect: true },
      { id: 'b', text: 'They focus on purification of belief and morality', isCorrect: true },
      { id: 'c', text: 'They tend to be shorter and more concise', isCorrect: true },
      { id: 'd', text: 'They contain more legal rulings and specific legislation', isCorrect: false }
    ],
    explanation: 'Makki surahs often begin with "Oh people" (addressing everyone), focus on purifying belief and understanding of morality, and tend to be shorter and more concise. They generally emphasize calling people to Allah and the excellence of Allah\'s creation through powerful language.',
    topic: 'qur101'
  },
  {
    id: 'qur007',
    text: 'What are the primary characteristics of Madani surahs?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'They often begin with "Oh you who believe" (addressing believers)', isCorrect: true },
      { id: 'b', text: 'They focus on perfecting practice and implementing legislation', isCorrect: true },
      { id: 'c', text: 'They tend to be longer and more detailed', isCorrect: true },
      { id: 'd', text: 'They discuss hypocrites in clarity', isCorrect: true },
      { id: 'e', text: 'They primarily focus on correcting disbelievers\' beliefs', isCorrect: false }
    ],
    explanation: 'Madani surahs often begin with "Oh you who believe" (addressing believers), focus on perfection of practice and implementation of legislation, tend to be longer and more detailed, and discuss hypocrites in clarity. They generally emphasize systems, laws, and practical applications of faith.',
    topic: 'qur101'
  },
  {
    id: 'qur008',
    text: 'What factors might cause differences of opinion regarding whether a surah is Makki or Madani?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Some surahs were revealed twice (once in each era)', isCorrect: true },
      { id: 'b', text: 'Some surahs have themes that can fit into both periods', isCorrect: true },
      { id: 'c', text: 'Some surahs have structure and content that fit both periods', isCorrect: true },
      { id: 'd', text: 'Some surahs address believers/people in ways fitting both eras', isCorrect: true },
      { id: 'e', text: 'Deliberate confusion introduced by later scholars', isCorrect: false }
    ],
    explanation: 'Differences of opinion on the classification of surahs can arise when: a surah was revealed twice (once in each era), the themes can fit into both periods, the structure and content can fit both periods, or when a surah addresses believers/people in a way that fits both eras.',
    topic: 'qur101'
  },
  {
    id: 'qur009',
    text: 'What is significant about Sūrat al-Qaṣas in terms of its revelation timing?',
    type: 'single',
    options: [
      { id: 'a', text: 'It was revealed partially in Makkah and partially in Madinah', isCorrect: false },
      { id: 'b', text: 'It was revealed during the hijrah journey', isCorrect: true },
      { id: 'c', text: 'It was the final surah to be revealed', isCorrect: false },
      { id: 'd', text: 'It was revealed before the Prophet\'s mission began', isCorrect: false }
    ],
    explanation: 'Sūrat al-Qaṣas is significant because it was revealed during the hijrah (migration) journey itself. Scholars researched its themes and characteristics to determine whether it should be classified as Makkan or Madani, with the majority opinion favoring Makkan classification because the hijrah was not yet complete.',
    topic: 'qur101'
  },
  {
    id: 'qur010',
    text: 'Which opinions exist regarding the first revelation to Prophet Muhammad ﷺ?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The first five verses of Sūrat al-\'Alaq', isCorrect: true },
      { id: 'b', text: 'Sūrat al-Fātiḥah (as the first complete surah)', isCorrect: true },
      { id: 'c', text: 'The beginning verses of Sūrat al-Muddathir', isCorrect: true },
      { id: 'd', text: 'Sūrat al-Qadr', isCorrect: false }
    ],
    explanation: 'There are multiple opinions about the first revelation: (1) The first five verses of Sūrat al-\'Alaq, supported by a strong hadith from Aisha RA; (2) Sūrat al-Fātiḥah, considered the first surah revealed in its entirety; and (3) The beginning verses of Sūrat al-Muddathir, based on a hadith from Jabir ibn Abdillah.',
    topic: 'qur101'
  },
  {
    id: 'qur011',
    text: 'Which opinions exist regarding the last revelation to Prophet Muhammad ﷺ?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Verse on riba from Sūrat al-Baqarah', isCorrect: true },
      { id: 'b', text: 'Sūrat an-Naṣr', isCorrect: true },
      { id: 'c', text: 'Verse 3 from Sūrat al-Mā\'idah about completing the religion', isCorrect: true },
      { id: 'e', text: 'Verse 281 from Sūrat al-Baqarah about returning to Allah', isCorrect: true },
      { id: 'd', text: 'Sūrat al-Fīl', isCorrect: false }
    ],
    explanation: 'Several opinions exist regarding the last revelation: (1) Verses on riba from Sūrat al-Baqarah (though this has weak support); (2) Sūrat an-Naṣr, which sounds like it belongs to the end of revelation; (3) Verse 3 from Sūrat al-Mā\'idah about completing the religion (revealed 87 nights before the Prophet\'s passing); and (4) Verse 281 from Sūrat al-Baqarah about returning to Allah.',
    topic: 'qur101'
  },
  {
    id: 'qur012',
    text: 'What is Sabab un-Nuzūl (circumstance of revelation)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The way the Qur\'ān was memorized by the companions', isCorrect: false },
      { id: 'b', text: 'The reason, cause, or occasion for the revelation of a specific verse', isCorrect: true },
      { id: 'c', text: 'The process of compiling the Qur\'ān after the Prophet\'s death', isCorrect: false },
      { id: 'd', text: 'The different modes of recitation of the Qur\'ān', isCorrect: false }
    ],
    explanation: 'Sabab un-Nuzūl refers to the reason, cause, or circumstance of revelation. It can be either informative (no specific cause) or circumstantial (specific to what was happening at the time and place of revelation).',
    topic: 'qur101'
  },
  {
    id: 'qur013',
    text: 'What are some benefits of understanding Sabab un-Nuzūl (circumstance of revelation)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Understanding the procedure behind commandments (e.g., stages of prohibition)', isCorrect: true },
      { id: 'b', text: 'Understanding the true meaning of verses that could be misinterpreted', isCorrect: true },
      { id: 'c', text: 'Understanding passing references that might be unclear', isCorrect: true },
      { id: 'd', text: 'Predicting future events based on past revelations', isCorrect: false }
    ],
    explanation: 'Benefits of understanding Sabab un-Nuzūl include: understanding the procedure behind commandments (e.g., the three stages of prohibition of intoxicants), understanding the true meaning of verses that could be misinterpreted, and understanding passing references that might be unclear without context.',
    topic: 'qur101'
  },
  {
    id: 'qur014',
    text: 'How can we identify the circumstances of revelation in hadith?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Through clear wording that explicitly states the reason', isCorrect: true },
      { id: 'b', text: 'Through unclear wording that requires inference', isCorrect: true },
      { id: 'c', text: 'Through time indicators that help establish context', isCorrect: true },
      { id: 'd', text: 'Through dream interpretations of the companions', isCorrect: false }
    ],
    explanation: 'We can identify circumstances of revelation through: clear wording that explicitly states the reason ("This was sent in..."), unclear wording that requires inference ("It was revealed in..." without explicit mention of reason), and time indicators that help establish context (e.g., knowing a surah was revealed before a certain event).',
    topic: 'qur101'
  },
  {
    id: 'qur015',
    text: 'What should be done when there are multiple narrations about the reason for a revelation?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Consider that the surah may have come down more than once', isCorrect: true },
      { id: 'b', text: 'Take the more authentic hadith when authenticity differs', isCorrect: true },
      { id: 'c', text: 'Consider that multiple events may have prompted the same ruling', isCorrect: true },
      { id: 'd', text: 'Always choose the narration that came from Aisha RA', isCorrect: false }
    ],
    explanation: 'When there are multiple narrations about the reason for a revelation, we should: consider that the surah may have come down more than once (first as revelation, later as a reminder), take the more authentic hadith when authenticity differs, and consider that multiple events may have prompted the same ruling (to institutionalize it).',
    topic: 'qur101'
  },
  {
    id: 'qur016',
    text: 'What does Jam\'ul Qur\'ān (جَمعُ القُرءان) mean?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Linguistically: to gather or collect something', isCorrect: true },
      { id: 'b', text: 'Practically: the preservation and protection of the Qur\'ān', isCorrect: true },
      { id: 'c', text: 'The process of interpreting the Qur\'ān', isCorrect: false },
      { id: 'd', text: 'The science of Qur\'anic recitation', isCorrect: false }
    ],
    explanation: 'Jam\'ul Qur\'ān (جَمعُ القُرءان) linguistically means "to gather or collect something," and practically refers to the preservation and protection of the Qur\'ān through various methods.',
    topic: 'qur101'
  },
  {
    id: 'qur017',
    text: 'What were the main eras of the preservation of the Qur\'ān?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'During the time of Prophet Muhammad ﷺ (era of memorization)', isCorrect: true },
      { id: 'b', text: 'During the time of Abu Bakr RA (era of formalization)', isCorrect: true },
      { id: 'c', text: 'During the time of Uthman RA (era of standardization)', isCorrect: true },
      { id: 'd', text: 'During the time of the Abbasid caliphate', isCorrect: false }
    ],
    explanation: 'The main eras of Qur\'anic preservation were: during the time of Prophet Muhammad ﷺ (the era of ḥifẓ/memorization), during the time of Abu Bakr RA (the era of formalization), and during the time of Uthman RA (the era of standardization).',
    topic: 'qur101'
  },
  {
    id: 'qur018',
    text: 'What methods were used to preserve the Qur\'ān during the Prophet\'s time?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Memorization (Ḥifẓ)', isCorrect: true },
      { id: 'b', text: 'Writing on various materials', isCorrect: true },
      { id: 'c', text: 'Regular recitation and review', isCorrect: true },
      { id: 'd', text: 'Printing on paper', isCorrect: false }
    ],
    explanation: 'During the Prophet\'s time, the Qur\'ān was preserved through: memorization (Ḥifẓ), which was the primary method; writing on various materials (bones, leaves, mountains, parchment, etc.); and regular recitation and review.',
    topic: 'qur101'
  },
  {
    id: 'qur019',
    text: 'What prompted Abu Bakr RA to compile the Qur\'ān into a manuscript?',
    type: 'single',
    options: [
      { id: 'a', text: 'The death of the Prophet Muhammad ﷺ', isCorrect: false },
      { id: 'b', text: 'The martyrdom of many huffāẓ (memorizers) at the Battle of Yamāmah', isCorrect: true },
      { id: 'c', text: 'The increasing number of non-Arab Muslims', isCorrect: false },
      { id: 'd', text: 'Personal desire to have a written copy', isCorrect: false }
    ],
    explanation: 'Abu Bakr RA was prompted to compile the Qur\'ān into a manuscript after the Battle of Yamāmah, where many huffāẓ (memorizers of the Qur\'ān) were martyred. Umar RA suggested the compilation out of concern for the future preservation of the Qur\'ān, especially if more huffāẓ were to be martyred in future battles.',
    topic: 'qur101'
  },
  {
    id: 'qur020',
    text: 'Who was tasked with compiling the official manuscript of the Qur\'ān during Abu Bakr\'s time?',
    type: 'single',
    options: [
      { id: 'a', text: 'Umar ibn al-Khattab', isCorrect: false },
      { id: 'b', text: 'Zaid ibn Thabit', isCorrect: true },
      { id: 'c', text: 'Ali ibn Abi Talib', isCorrect: false },
      { id: 'd', text: 'Uthman ibn Affan', isCorrect: false }
    ],
    explanation: 'Zaid ibn Thabit was tasked with compiling the official manuscript of the Qur\'ān during Abu Bakr\'s time. He was chosen because he was a passionate, reasonable, and trustworthy individual who had served as a scribe for the Prophet ﷺ during revelations.',
    topic: 'qur101'
  },
  {
    id: 'qur021',
    text: 'Why did Uthman RA standardize the Qur\'ān?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Due to the wide expansion of Islam creating decentralized knowledge', isCorrect: true },
      { id: 'b', text: 'Because Muslims were reciting with different aḥruf without knowing others were valid', isCorrect: true },
      { id: 'c', text: 'Because people were doing takfīr of each other over different recitations', isCorrect: true },
      { id: 'd', text: 'To add his own personal interpretations to the text', isCorrect: false }
    ],
    explanation: 'Uthman RA standardized the Qur\'ān because: the wide expansion of Islam created a decentralized system of knowledge that couldn\'t scale, Muslims were reciting with different aḥruf without knowing other valid ones existed, and people were doing takfīr of each other over different recitations, which had serious implications.',
    topic: 'qur101'
  },
  {
    id: 'qur022',
    text: 'What action did Uthman RA take regarding personal manuscripts of the Qur\'ān?',
    type: 'single',
    options: [
      { id: 'a', text: 'He collected and stored them in the treasury', isCorrect: false },
      { id: 'b', text: 'He ordered them to be burned, except for confirmed correct ones', isCorrect: true },
      { id: 'c', text: 'He distributed them to different regions', isCorrect: false },
      { id: 'd', text: 'He had them translated into different languages', isCorrect: false }
    ],
    explanation: 'Uthman RA ordered personal manuscripts to be burned, except for those of the ṣaḥābah and others who had confirmed correct manuscripts. This was done because there were manuscripts that were incorrect or had unclear distinctions between footnotes and the Qur\'ānic text itself, leading to confusion and takfīr over differences.',
    topic: 'qur101'
  },
  {
    id: 'qur023',
    text: 'What does "the seven aḥruf" of the Qur\'ān refer to?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Small dialectical changes or modes of recitation in certain parts of the Qur\'ān', isCorrect: true },
      { id: 'b', text: 'Divine canonical recitations that came from Allāh SWT', isCorrect: true },
      { id: 'c', text: 'Different ways of reciting that made the Qur\'ān easier for different tribes', isCorrect: true },
      { id: 'd', text: 'Seven completely different versions of the Qur\'ān', isCorrect: false }
    ],
    explanation: 'The "seven aḥruf" refers to small dialectical changes or modes of recitation in certain parts of the Qur\'ān. They are divine canonical recitations that came from Allāh SWT, not human inventions, and were given as a mercy to make recitation easier for different Arab tribes who had varying dialects.',
    topic: 'qur101'
  },
  {
    id: 'qur024',
    text: 'What are the different types of changes that might occur within the seven aḥruf?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Changes in vowelization', isCorrect: true },
      { id: 'b', text: 'Changes in verb tense', isCorrect: true },
      { id: 'c', text: 'Changes using synonyms', isCorrect: true },
      { id: 'd', text: 'Changes in word order', isCorrect: true },
      { id: 'e', text: 'Changes in core theological principles', isCorrect: false }
    ],
    explanation: 'The types of changes that might occur within the seven aḥruf include: changes in vowelization, changes in verb tense, the use of synonymous words, and changes in word order. These differences are minute and only affect certain words, never changing core theological principles or rulings.',
    topic: 'qur101'
  },
  {
    id: 'qur025',
    text: 'What is the difference between aḥruf and qirā\'āt?',
    type: 'single',
    options: [
      { id: 'a', text: 'They are exactly the same thing with different names', isCorrect: false },
      { id: 'b', text: 'Aḥruf are the ingredients, while qirā\'āt are the science of combining them into canonical recitations', isCorrect: true },
      { id: 'c', text: 'Aḥruf are invented, while qirā\'āt are divine', isCorrect: false },
      { id: 'd', text: 'Aḥruf are only seven, while qirā\'āt are unlimited', isCorrect: false }
    ],
    explanation: 'Aḥruf are the ingredients (the divine variants), while qirā\'āt are the science of combining these aḥruf into canonical recitations. Qirā\'āt require specific chain of narration (isnād) back to the Prophet ﷺ and involve specific rules for recitation.',
    topic: 'qur101'
  },
  {
    id: 'qur026',
    text: 'What is naskh (abrogation) in the context of the Qur\'ān?',
    type: 'single',
    options: [
      { id: 'a', text: 'The translation of the Qur\'ān into other languages', isCorrect: false },
      { id: 'b', text: 'The lifting of a legal ruling by another legal ruling', isCorrect: true },
      { id: 'c', text: 'The process of memorizing the Qur\'ān', isCorrect: false },
      { id: 'd', text: 'The writing style of Qur\'anic calligraphy', isCorrect: false }
    ],
    explanation: 'Naskh (abrogation) linguistically means "to transcribe or copy something," but technically (iṣtilāḥan) it means "the lifting of a legal ruling by another legal ruling." It refers to when a verse or ruling is replaced by another that comes later.',
    topic: 'qur101'
  },
  {
    id: 'qur027',
    text: 'What are the three categories of naskh (abrogation) according to scholars?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Where both the ruling and recitation are abrogated', isCorrect: true },
      { id: 'b', text: 'Where the recitation is abrogated but the ruling remains', isCorrect: true },
      { id: 'c', text: 'Where the ruling is abrogated but the recitation remains', isCorrect: true },
      { id: 'd', text: 'Where neither the ruling nor the recitation is abrogated', isCorrect: false }
    ],
    explanation: 'The three categories of naskh (abrogation) are: (1) where both the ruling and recitation are abrogated (verses no longer in the Qur\'ān and rulings no longer valid), (2) where the recitation is abrogated but the ruling remains (verses not in the final Qur\'ān but rulings still applied), and (3) where the ruling is abrogated but the recitation remains (verses still in the Qur\'ān but we don\'t act upon them).',
    topic: 'qur101'
  },
  {
    id: 'qur028',
    text: 'What is tafsīr linguistically and technically?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Linguistically: to untie something', isCorrect: true },
      { id: 'b', text: 'Technically: the science and methodology of interpreting the Qur\'ān', isCorrect: true },
      { id: 'c', text: 'A process requiring careful qualification and proper sources', isCorrect: true },
      { id: 'd', text: 'The memorization of the Qur\'ān', isCorrect: false }
    ],
    explanation: 'Tafsīr linguistically means "to untie something" (from the root ف س ر), and technically refers to the science and methodology of interpreting the Qur\'ān. It is a process that requires careful qualification and proper sources, as it is not a light task and can lead to misguiding people if done improperly.',
    topic: 'qur101'
  },
  {
    id: 'qur029',
    text: 'What are the primary sources of tafsīr in order of importance?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Tafsīr of the Qur\'ān by the Qur\'ān itself', isCorrect: true },
      { id: 'b', text: 'Tafsīr by the Sunnah/Hadith', isCorrect: true },
      { id: 'c', text: 'Tafsīr by the statements of the Companions', isCorrect: true },
      { id: 'd', text: 'Tafsīr by the statements of the Tābi\'īn (Successors)', isCorrect: true },
      { id: 'e', text: 'Tafsīr by the Arabic language', isCorrect: true },
      { id: 'f', text: 'Modern scholarly consensus', isCorrect: false }
    ],
    explanation: 'The primary sources of tafsīr in order of importance are: (1) Tafsīr of the Qur\'ān by the Qur\'ān itself, (2) Tafsīr by the Sunnah/Hadith, (3) Tafsīr by the statements of the Companions, (4) Tafsīr by the statements of the Tābi\'īn (Successors), and (5) Tafsīr by the Arabic language. These are followed by Ta\'wīl (personal interpretation), which is considered secondary.',
    topic: 'qur101'
  },
  {
    id: 'qur030',
    text: 'What categories are texts classified into regarding clarity and authenticity?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Qaṭ\'ī uth-Thubūt (definitive in authenticity)', isCorrect: true },
      { id: 'b', text: 'Ẓannī uth-Thubūt (speculative in authenticity)', isCorrect: true },
      { id: 'c', text: 'Qaṭ\'ī ud-Dalālah (definitive in meaning)', isCorrect: true },
      { id: 'd', text: 'Ẓannī ud-Dalālah (speculative in meaning)', isCorrect: true },
      { id: 'e', text: 'Qaṭ\'ī ul-Lafẓ (definitive in wording)', isCorrect: false }
    ],
    explanation: 'Texts are categorized in terms of: (1) Thubūt (authenticity): Qaṭ\'ī (definitive) or Ẓannī (speculative), and (2) Dalālah (meaning/indication): Qaṭ\'ī (definitive) or Ẓannī (speculative). The entire Qur\'an is considered Qaṭ\'ī uth-Thubūt (definitive in authenticity), though many verses are Ẓannī ud-Dalālah (could have multiple meanings).',
    topic: 'qur101'
  }
];
